/*** API model
 *   General api object where automatically errors are displayed in a toast and Authorization header is added.
 */
import axios from 'axios';
import store from '../store/store';

// const baseDomain = "https://api.gastro-inox.eu/admin/";
const baseDomain = "https://api.gastro-inox.eu/";
const devBaseDomain = "https://staging.api.gastro-inox.eu/";
// const devBaseDomain = "http://gastro-inox.test/";
export const baseUrl = `${baseDomain}`;

// let isAlreadyFetchingAccessToken = false;

const api = axios.create({
    baseURL: process.env.NODE_ENV == 'production' ? baseDomain : devBaseDomain,
});

//intercept all requests to check for any errors
api.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    const { config, response: { status } } = error;
    //const originalRequest = config;
    console.log(config);
    if (status === 401) {
        /*if (!isAlreadyFetchingAccessToken) {
            isAlreadyFetchingAccessToken = true;

            // instead of this store call you would put your code to get new token
            return new Promise((resolve, reject) => {
                console.log("hoi");
                store.dispatch('auth/_fetchAccessToken').then((access_token) => {
                    isAlreadyFetchingAccessToken = false;
                    originalRequest.headers.Authorization = 'Bearer ' + access_token
                    resolve(axios(originalRequest))
                }).catch(()=>{
                    isAlreadyFetchingAccessToken = false;
                    store.dispatch('auth/_logout').then();
                    reject(error);
                });
            });
        }*/
        store.dispatch('auth/_logout').then();
    }
    return Promise.reject(error);
});
export default api
